const LogoutModal = ({ isOpen, darkMode, onConfirm, onCancel }) => {
    if (!isOpen) return null;

    return (
        <div className="logoutModalOverlay">
            <div 
                className="logoutModal" 
                style={{ 
                    backgroundColor: darkMode ? '#333' : 'white', 
                    color: darkMode ? 'white' : 'black' 
                }}
            >
                <h3>
                    Confirm Logout
                </h3>

                <p>
                    Are you sure you want to logout?
                </p>

                <div className="modalButtons">
                    <button className="cancelBtn" onClick={onCancel}>
                        Cancel
                    </button>

                    <button className="confirmBtn" onClick={onConfirm}>
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};
export default LogoutModal;